'use client';

import DOMPurify from 'isomorphic-dompurify';
import Script from 'next/script';
import { PropsWithChildren, useEffect } from 'react';

import { NAJVA_CONFIG } from '@/lib/providers/lib/najva.config';

const najvaSetupScript = DOMPurify.sanitize(`
  window.NAJVA = window.NAJVA || {};

  var s = document.createElement("script");
  s.src = "${NAJVA_CONFIG.scriptUrl}";
  s.defer = true;
  s.id = "najva-mini-script";
  s.setAttribute("data-najva-id", "${NAJVA_CONFIG.websiteId}");

  document.head.appendChild(s);
`);

const MAX_RETRY = 20;
const RETRY_DELAY = 500;

export function NajvaProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    if (!NAJVA_CONFIG.enabled) return;

    let retryCount = 0;
    let timeoutId: ReturnType<typeof setTimeout>;

    const waitForSDK = () => {
      if (window.NAJVA?.getUserToken) {
        // console.log('Najva SDK Ready');
        return;
      }

      if (retryCount >= MAX_RETRY) {
        console.error('Najva SDK failed to initialize.');
        return;
      }

      retryCount++;

      timeoutId = setTimeout(waitForSDK, RETRY_DELAY);
    };

    waitForSDK();

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      {NAJVA_CONFIG.enabled && (
        <Script
          id='najva-setup'
          strategy='afterInteractive'
          dangerouslySetInnerHTML={{ __html: najvaSetupScript }}
        />
      )}

      {children}
    </>
  );
}
